import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud(
	'bank_key_electronic_payment',
	'Clave de banco pago electronico',
	'Claves de banco pago electronico',
)

export default { ...actions, }
